import React, { useRef, useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./blogs.css";
import DefultImg from '../../assets/images/defult-img copy.svg'


import { Skeleton } from 'primereact/skeleton';

// Uncomment and use if API is integrated
import { getGallery } from '../../utils/api';

export default function ProductsSlider({ galleryData }) {
    const [loading, setLoading] = useState(true); // حالت لودینگ
    const [visible, setVisible] = useState(false); // Dialog visibility state
    const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
    // Fetch products data from API


    const settings = {
        arrows: false, // نمایش یا عدم نمایش پیکان‌ها
        autoplaySpeed: 3000,

        responsive: [
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: true,
                    rtl: galleryData?.length > 5,
                    autoplay: galleryData?.length > 5, // فعال‌سازی خودکار
                    draggable: galleryData.length > 5,
                    infinite: galleryData.length > 5, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    rtl: galleryData?.length > 4,
                    slidesToShow: 4,
                    arrows: true,
                    slidesToScroll: 1,
                    autoplay: galleryData?.length > 4, // فعال‌سازی خودکار
                    draggable: galleryData.length > 4,
                    infinite: galleryData.length > 4, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    rtl: galleryData?.length > 3,
                    slidesToShow: 3,
                    arrows: true,
                    slidesToScroll: 1,
                    autoplay: galleryData?.length > 3, // فعال‌سازی خودکار
                    draggable: galleryData.length > 3,
                    infinite: galleryData.length > 3, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 900,
                settings: {
                    rtl: galleryData?.length > 3,
                    slidesToShow: 3,
                    arrows: true,
                    slidesToScroll: 1,
                    autoplay: galleryData.length > 3, // اضافه کردن autoplay در اینجا
                    autoplaySpeed: 3000,
                    draggable: galleryData.length > 3,
                    infinite: galleryData.length > 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    rtl: galleryData?.length > 2,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: galleryData.length > 2, // اضافه کردن autoplay در اینجا
                    autoplaySpeed: 3000,
                    draggable: galleryData.length > 2,
                    infinite: galleryData.length > 2,
                },
            },
        ],
    };
    function convertToPersianNumbers(input) {
        if (input) {
    
          const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
          return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
      }

    return (
        <>



            <Slider {...settings} adaptiveHeight={true}>
                {galleryData.map((product, index) => (
                    <div className='blog-list' style={{ width: 'auto' }}>
                        <div className='blog-item'>
                            <div className='blog-img aspect-[3/3]'>
                                <img
                                    src={product.Pic ? product.Pic : DefultImg}
                                    className='img-box img-product'
                                    alt="Image"
                                    onError={(e) => {
                                        e.target.onerror = null; // جلوگیری از لوپ بی‌نهایت
                                        e.target.src = DefultImg;
                                    }}
                                />                            </div>
                            <div className='detail'>
                                <div>
                                    <h4 className=' mt-2'>{convertToPersianNumbers(product.TpA)}</h4>
                                    {/* <h6 className='mt-2 body-blog'></h6> */}
                                </div>
                            </div>


                        </div>
                    </div>
                ))}


            </Slider>


        </>
    );
};

